import axios from "axios";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
const appauth_key = "dfoodo@2029";
let APL_LINK = "http://192.168.1.7:8000/";
//APL_LINK = "http://192.168.1.8:8000/";
APL_LINK = "https://dfoodobackend.dfoodo.com/";
let Website_URL = "https://www.dfoodo.com/";
let local_server_link_react = APL_LINK + "api/super_admin_link/";
let local_server_link_react_admin = APL_LINK + "api/admin_link/";
let feedback_online_link = "https://www.wowreviews.co/Adminmaster/";

// API functions

const login_to_superadmin = local_server_link_react + "login_to_superadmin";
const save_update_testimonial = local_server_link_react + "save_update_testimonial";
const get_all_testimonial = local_server_link_react + "get_all_testimonial";
const get_all_enquiry = local_server_link_react + "get_all_enquiry";
const forgot_password = local_server_link_react + "forgot_password";
const check_resetlink_vaild = local_server_link_react + "check_resetlink_vaild";
const change_password_by_forgot =
  local_server_link_react + "change_password_by_forgot";
const save_update_staff = local_server_link_react + "save_update_admin_staff";
const get_all_staff = local_server_link_react + "get_admin_all_staff";
const action_update_staff =
  local_server_link_react + "action_update_admin_staff";
const save_update_designtion =
  local_server_link_react + "save_update_admin_designtion";
const get_all_guestInformation =
  local_server_link_react + "get_all_guestInformation_superadmin";
const update_guest_vip_status =
  local_server_link_react_admin + "update_guest_vip_status";
const view_calender_reservation =
  local_server_link_react + "view_calender_reservation";
const view_reservation_history =
  local_server_link_react + "view_reservation_history_super_admin";
const update_profile_staff =
  local_server_link_react + "update_profile_admin_staff";

const save_update_faq = local_server_link_react_admin + "save_update_faq";
const get_all_faq = local_server_link_react_admin + "get_all_faq";
const save_update_knowledgebase =
  local_server_link_react + "save_update_knowledgebase";
const get_all_knowledgebase = local_server_link_react + "get_all_knowledgebase";
const get_all_restaurant_owner =
  local_server_link_react + "get_all_restaurant_owner";
const get_all_reviews_restaurant =
  local_server_link_react + "get_all_reviews_restaurant";

const get_all_diningarea = local_server_link_react + "get_all_diningarea";
const delete_diningarea = local_server_link_react + "delete_diningarea";
const update_primary_diningarea =
  local_server_link_react + "update_primary_diningarea";
const update_diningarea_sequence =
  local_server_link_react + "update_diningarea_sequence";
const get_all_table_position = local_server_link_react + "get_all_tablesetup";
const get_all_table_position2 = local_server_link_react + "get_all_tablesetup2";
const sava_update_table_position = local_server_link_react + "save_tablesetup";
const delete_tablesetup = local_server_link_react + "delete_tablesetup";
const get_all_new_resturant_onboarding =
  local_server_link_react + "get_all_new_resturant_onboarding";

const save_new_resturant = local_server_link_react + "save_new_resturant";
const save_resturant_images_menu =
  local_server_link_react + "save_resturant_images_menu";
const get_all_new_resturant = local_server_link_react + "get_all_new_resturant";
const delete_resturant_images_menu =
  local_server_link_react + "delete_resturant_images_menu";
const action_update_resturant =
  local_server_link_react + "action_update_resturant";

const view_special_timing =
  local_server_link_react_admin + "view_special_timing";
const view_week_all_timing =
  local_server_link_react_admin + "view_week_all_timing";
const save_update_special_timing =
  local_server_link_react_admin + "save_update_special_timing";
const save_update_week_timing =
  local_server_link_react_admin + "save_update_week_timing";
const allot_table_to_reservation =
  local_server_link_react + "allot_table_to_reservation";
const get_all_StaffRights =
  local_server_link_react + "get_all_admin_staffRights";
const save_update_StaffRights =
  local_server_link_react + "save_update_admin_StaffRights";
const save_update_general_Settings =
  local_server_link_react_admin + "save_update_general_Settings";
const get_all_ReservationSetting =
  local_server_link_react_admin + "get_all_ReservationSetting";
const get_all_reservation_date_notification =
  local_server_link_react + "get_all_reservation_date_notification";
const get_all_reservation_date =
  local_server_link_react + "get_all_reservation_date";
const update_action_reservation =
  local_server_link_react_admin + "update_action_reservation";
const table_release_from_reservation =
  local_server_link_react + "table_release_from_reservation";
const get_all_timing_date_wise =
  local_server_link_react + "get_all_timing_date_wise";
const create_table_reservation_staff =
  local_server_link_react + "create_table_reservation_staff";
const get_all_floor_data = local_server_link_react + "get_all_floor_data";
const action_update_staff_right =
  local_server_link_react + "action_update_admin_staff_right";
const get_all_designation =
  local_server_link_react + "get_all_admin_designation";
const update_calender_seat_status =
  local_server_link_react + "update_calender_seat_status";
const check_no_show_review = local_server_link_react + "check_no_show_review";
const get_all_analyticsReservation =
  local_server_link_react_admin + "get_all_analyticsReservation";
const get_analyticsReservationHourly =
  local_server_link_react_admin + "get_analyticsReservationHourly";
const get_reservation_by_mobile_no =
  local_server_link_react + "get_reservation_by_mobile_no";
const get_all_notification = local_server_link_react + "get_all_notification";
const update_notification_status =
  local_server_link_react + "update_notification_status";

const feedback_dashboard_view =
  feedback_online_link + "feedback_dashboard_view";
const bad_bus_search_api = feedback_online_link + "bad_bus_search_api";

const get_all_searchmaster =
  local_server_link_react_admin + "get_all_searchmaster";
const save_update_searchmaster =
  local_server_link_react_admin + "save_update_searchmaster";
const insert_note_from_feedback =
  local_server_link_react + "insert_note_from_feedback";
const get_all_notes_by_id =
  local_server_link_react_admin + "get_all_notes_by_id";
const get_all_RestaurantsReport =
  local_server_link_react + "get_all_RestaurantsReport";
const get_all_RestaurantsownerReport =
  local_server_link_react + "get_all_RestaurantsownerReport";
const get_all_ReportsSales =
  local_server_link_react_admin + "get_all_ReportsSales";
const get_all_guestReport =
  local_server_link_react_admin + "get_all_guestReport";
const get_all_ReportsReservation =
  local_server_link_react_admin + "get_all_ReportsReservation";
const get_all_tablesetup2_for_edit =
  local_server_link_react + "get_all_tablesetup2_for_edit";

/**website links */
const get_all_subscribe = local_server_link_react + "get_all_subscribe";
const save_update_blog = local_server_link_react + "save_update_blog";
const get_all_blogs = local_server_link_react + "get_all_blogs";
const save_update_seo = local_server_link_react + "save_update_seo";
const get_all_seo = local_server_link_react + "get_all_seo";
const save_update_imagelink = local_server_link_react + "save_update_imagelink";
const get_all_imagelink = local_server_link_react + "get_all_imagelink";
const save_update_team = local_server_link_react + "save_update_team";
const get_all_team = local_server_link_react + "get_all_team";
const save_update_EventResturant =
  local_server_link_react + "save_update_EventResturant";
const get_all_EventResturant =
  local_server_link_react + "get_all_EventResturant";
const get_update_terms_privacy =
  local_server_link_react + "get_update_terms_privacy";
const get_all_WebsiteCaps = local_server_link_react + "get_all_WebsiteCaps";
const save_update_WebsiteCaps =
  local_server_link_react + "save_update_WebsiteCaps";
const delete_website_master_data =
  local_server_link_react + "delete_website_master_data";
const get_all_Vacancy = local_server_link_react + "get_all_Vacancy";
const save_update_Vacancy = local_server_link_react + "save_update_Vacancy";
const update_data_career = local_server_link_react + "update_data_career";
const get_all_WebsiteManagement =
  local_server_link_react + "get_all_WebsiteManagement";
const save_update_WebsiteManagement =
  local_server_link_react + "save_update_WebsiteManagement";
const get_all_admin_category =
  local_server_link_react + "get_all_admin_category";
const get_all_admin_cuinise = local_server_link_react + "get_all_admin_cuinise";
const get_all_admin_amenities =
  local_server_link_react + "get_all_admin_amenities";
const save_update_category_super =
  local_server_link_react + "save_update_category_super";
const delete_super_master_data =
  local_server_link_react + "delete_super_master_data";
const active_status_super_master =
  local_server_link_react + "active_status_super_master";
const save_update_cuinise_super =
  local_server_link_react + "save_update_cuinise_super";
const save_update_amenities_super =
  local_server_link_react + "save_update_amenities_super";
const get_all_admin_Country = local_server_link_react + "get_all_admin_Country";
const get_all_admin_City = local_server_link_react + "get_all_admin_City";
const save_update_city_super =
  local_server_link_react + "save_update_city_super";
const delete_city_super = local_server_link_react + "delete_city_super";
const get_all_tickets = local_server_link_react + "get_all_tickets";
const get_country_data = local_server_link_react + "get_country_data";
const resolve_ticket_by_user =
  local_server_link_react + "resolve_ticket_by_user";
const get_save_update_tickets =
  local_server_link_react + "get_save_update_tickets";
const get_save_update_tickets_details =
  local_server_link_react + "get_save_update_tickets_details";
const get_all_restaurant_list =
  local_server_link_react + "get_all_restaurant_list";

const classify_restaurant_subscriptions =
  local_server_link_react + "classify_restaurant_subscriptions";
const get_all_dashboard_data =
  local_server_link_react + "get_all_dashboard_data";
const save_restaurant_subscription =
  local_server_link_react + "save_restaurant_subscription";
const save_update_faq_website =
  local_server_link_react + "save_update_admin_faq";
const get_all_faq_website = local_server_link_react + "get_all_admin_faq";
const save_update_landmark = local_server_link_react + "save_update_landmark";
const get_landmark_data = local_server_link_react + "get_landmark_data";
const get_notification_data = local_server_link_react + "get_notification_data";
const add_notification_data = local_server_link_react + "add_notification_data";
const delete_master_all = local_server_link_react + "delete_master_all";
const get_all_Landmark_data = local_server_link_react + "get_all_Landmark_data";
const new_restaurant_install_btn =
  local_server_link_react + "new_restaurant_install_btn";
const get_subs_data = local_server_link_react + "get_subs_data";

// -----------------Addd Restaurent Api-------
const sava_onboarding_form =
  local_server_link_react_admin + "sava_onboarding_form";
const get_last_resturant_data_save =
  local_server_link_react_admin + "get_last_resturant_data_save";
const fssai_verification_combined =
  local_server_link_react_admin + "fssai_verification_combined";
const gst_verification_combined =
  local_server_link_react_admin + "gst_verification_combined";
const sava_onboarding_form_otp =
  local_server_link_react_admin + "sava_onboarding_form_otp";
/**website links */
// Retrieving data

const retrievedAdminId = retrieveData("admin_id");

const server_post_data = async (
  url_for,
  form_data,
  packageName = "Default"
) => {
  // const headers = {
  //   "Content-Type": "application/json",
  // };
  // const packageName = "Default"; // or dynamic value
  if (form_data === null) {
    form_data = new FormData();
  }
  form_data.append("admin_id", "0");
  form_data.append("super_admin_id", retrievedAdminId);
  form_data.append("appauth_key", appauth_key);
  if (form_data.get("data_call") !== null) {
    form_data.append("call_id", retrievedAdminId);
  }
  return axios.post(url_for, form_data, {
    headers: {
      "X-Package-Name": packageName,
      "Content-Type": "multipart/form-data", // If you're sending form data
    },
  });
};

export {
  APL_LINK,
  Website_URL,
  appauth_key,
  server_post_data,
  get_all_table_position,
  get_all_table_position2,
  sava_update_table_position,
  login_to_superadmin,
  forgot_password,
  check_resetlink_vaild,
  change_password_by_forgot,
  save_update_staff,
  get_all_staff,
  action_update_staff,
  get_all_guestInformation,
  view_calender_reservation,
  view_reservation_history,
  view_special_timing,
  view_week_all_timing,
  update_profile_staff,
  get_all_diningarea,
  delete_diningarea,
  delete_tablesetup,
  save_new_resturant,
  save_update_special_timing,
  get_all_StaffRights,
  save_update_StaffRights,
  get_all_new_resturant,
  action_update_resturant,
  save_update_week_timing,
  allot_table_to_reservation,
  save_update_general_Settings,
  get_all_ReservationSetting,
  get_all_reservation_date,
  update_action_reservation,
  table_release_from_reservation,
  get_all_timing_date_wise,
  create_table_reservation_staff,
  get_all_floor_data,
  action_update_staff_right,
  get_all_designation,
  save_update_designtion,
  feedback_dashboard_view,
  update_calender_seat_status,
  save_update_faq,
  get_all_faq,
  save_update_knowledgebase,
  get_all_knowledgebase,
  get_all_analyticsReservation,
  get_analyticsReservationHourly,
  get_reservation_by_mobile_no,
  get_all_notification,
  update_notification_status,
  update_guest_vip_status,
  update_primary_diningarea,
  update_diningarea_sequence,
  bad_bus_search_api,
  get_all_searchmaster,
  save_update_searchmaster,
  insert_note_from_feedback,
  get_all_notes_by_id,
  get_all_RestaurantsReport,
  get_all_ReportsSales,
  get_all_guestReport,
  get_all_reservation_date_notification,
  get_all_tablesetup2_for_edit,
  check_no_show_review,
  get_all_testimonial,
  get_all_enquiry,
  save_update_testimonial,
  //website Links
  save_update_blog,
  get_all_blogs,
  save_update_seo,
  get_all_seo,
  save_update_imagelink,
  get_all_imagelink,
  save_update_team,
  get_all_team,
  save_update_EventResturant,
  get_all_EventResturant,
  get_all_WebsiteCaps,
  save_update_WebsiteCaps,
  delete_website_master_data,
  get_all_Vacancy,
  save_update_Vacancy,
  update_data_career,
  get_all_WebsiteManagement,
  save_update_WebsiteManagement,
  get_all_subscribe,
  get_all_restaurant_owner,
  get_update_terms_privacy,
  get_all_RestaurantsownerReport,
  get_all_admin_category,
  get_all_admin_cuinise,
  get_all_admin_amenities,
  save_update_category_super,
  delete_super_master_data,
  active_status_super_master,
  save_update_cuinise_super,
  save_update_amenities_super,
  get_all_admin_City,
  get_all_admin_Country,
  save_update_city_super,
  delete_city_super,
  get_all_tickets,
  resolve_ticket_by_user,
  get_save_update_tickets,
  get_save_update_tickets_details,
  save_resturant_images_menu,
  delete_resturant_images_menu,
  get_all_reviews_restaurant,
  get_all_restaurant_list,
  get_all_ReportsReservation,
  get_all_dashboard_data,
  classify_restaurant_subscriptions,
  save_restaurant_subscription,
  get_country_data,
  save_update_faq_website,
  get_all_faq_website,
  get_landmark_data,
  save_update_landmark,
  add_notification_data,
  get_notification_data,
  delete_master_all,
  get_all_Landmark_data,
  sava_onboarding_form,
  get_last_resturant_data_save,
  gst_verification_combined,
  fssai_verification_combined,
  sava_onboarding_form_otp,
  get_all_new_resturant_onboarding,
  get_subs_data,
  new_restaurant_install_btn,
  //website Links
};
